import { IdentifikationsnachweisAusweisart } from '@mng/domain';
import { AntragStatus } from '@mng/sales-types';

export const ANTRAG_STATUS: { [key: string]: string } = {
  [AntragStatus.NICHT_UNTERSCHREIBBAR]: 'Nicht unterschreibbar',
  [AntragStatus.UNTERSCHREIBBAR]: 'Unterschreibbar',
  [AntragStatus.IN_UNTERSCHRIFT]: 'Wird unterschrieben',
  [AntragStatus.UEBERGELEITET]: 'Eingereicht'
};
export const IDENTIFIKATIONSNACHWEIS_AUSWEISART = {
  [IdentifikationsnachweisAusweisart.UNBEKANNT]: 'Unbekannt',
  [IdentifikationsnachweisAusweisart.FUEHRERSCHEIN]: 'Führerschein',
  [IdentifikationsnachweisAusweisart.ECARD]: 'E-Card',
  [IdentifikationsnachweisAusweisart.GEBURTSURKUNDE]: 'Geburtsurkunde',
  [IdentifikationsnachweisAusweisart.OEFFENTLICHER_DIENSTAUSWEIS]: 'öffentlicher Dienstausweis',
  [IdentifikationsnachweisAusweisart.PERSONALAUSWEIS]: 'Personalausweis',
  [IdentifikationsnachweisAusweisart.REISEPASS]: 'Reisepass',
  [IdentifikationsnachweisAusweisart.REISEPASS_ELTERN]: 'Reisepass Eltern',
  [IdentifikationsnachweisAusweisart.SCHUELERAUSWEIS]: 'Schülerausweis'
};
